export default {
  'profile.updatesuccess': 'Your profile updated successfully',
  'profile.insertsuccess': 'Your profile created successfully',
  'profile.profile': 'Profile',
  'profile.search': 'Search',
  'profile.oldpassword': 'Old Password',
  'profile.newpassword': 'New Password',
  'profile.logo': 'LOGO',
  'profile.workinghours': 'Working Hours',
  'profile.nationalcardfile': 'National Card File',
  'profile.addfile': 'Add File',
  'profile.editinformation': 'Edit Profile Information',
  'profile.email': 'Email',
  'profile.weekdays': 'Week Days',
  'profile.close': 'Close',
  'profile.savechanges': 'Save Changes',
  'profile.deleteconfirmation': 'Are you sure to delete ? ',
  'profile.rolename': 'Role Name',
  'profile.register': 'Register',
  'profile.delete': 'Delete',
  'profile.addemployee': 'Add New Employee',
  'profile.deleteemployee': 'Delete Employee',
  'profile.cancel': 'Cancel',
  'profile.number': 'Number',
  'profile.fromtime': 'From Time',
  'profile.totime': 'To Time',
  'profile.setworkinghours': 'Set Working Hours',
  'profile.phone': 'phone ',
  'profile.selectyear': 'Select Birth Year',
  'profile.selectmonth': 'Select Birth Month',
  'profile.selectday': 'Select Birth Day',
  'profile.address': 'Address ',
  'profile.companyname': 'Company Name',
  'profile.englishcompanyname': 'English Company Name',
  'profile.persiancompanyname': 'Local Company Name',
  'profile.webSite': 'Website',
  'profile.removeaddress': 'Remove Address',
  'profile.moreaddress': 'Add Address',
  'profile.removephone': 'Remove Phone',
  'profile.addphone': 'Add Phone',
  'profile.registercode': 'Register Code',
  'profile.managername': 'Manager/Agent Name (Required)',
  'profile.businessmanagername': 'Manager Name',
  'profile.type': 'Business Type (Required)',
  'profile.businesstype': 'Business Type',
  'profile.licensefile': 'License File',
  'profile.updatepassword': 'Please update your password to continue',
  'profile.editprofile': 'Edit Business Profile',
  'profile.individualprofile': 'Edit Profile',
  'profile.inviteemployee': 'Invite Employee',
  'profile.change': 'Change',
  'profile.firstname': 'First Name',
  'profile.lastname': 'Last Name',
  'profile.mobile': 'Mobile',
  'profile.nationalcode': 'National Code',
  'profile.password': 'Password',
  'profile.username': 'UserName',
  'profile.username/email': 'UserName / Email',
  'profile.gender': 'Gender',
  'profile.birthdate': 'Birth Date',
  'profile.selectavatar': 'Select Avatar',
  'profile.adminitstrator': 'adminitstrator',
  'profile.book/reserve': 'Transaction',
  'profile.changepassword': 'Change Password',
  'profile.editpersonalprofile': 'Edit Profile ',
  'profile.onlinesupport': 'support',
  'profile.employees': 'Employees',
  'profile.addprofile': 'Add New Business Profile',
  'profile.addbusiness': 'Add Business',
  'profile.encompanyname': 'English Company Name (Required)',
  'profile.facompanyname': 'Local Company Name (Required)',
  'profile.myprofile': 'My Profile',
  'profile.employeemanagement': 'Employee Management',
  'profile.airlinequota': 'Airline Quota',
  'profile.signiture': 'Profile Signiture',
  'profile.addsigniture': 'Save Signiture',
  'profile.quotaadd': 'Quota added successfully',
  'profile.signout': 'Logout',
  'profile.signituresave': 'Signiture saved successfully',
  'profile.signitureerror': 'Please try again',
  'profile.profiletype': 'SELECT PROFILE TYPE',
  'profile.profilsend':
    'Profile has been sent for verification.The results will be announced soon',
  'profile.suspend': 'SUSPEND',
  'profile.nationalid': 'National Code (Required)',
  'profile.businessnationalid': 'National Code',
  'profile.activitycode': 'Activity Code (Required)',
  'profile.economiccode': 'Economic Code (Required)',
  'profile.businessactivitycode': 'Activity Code',
  'profile.businesseconomiccode': 'Economic Code',
  'profile.choosegateway': 'Choose Gateway',
  'profile.testconnection': 'Test Connection',
  'profile.savesigniture': 'Save Signiture',
  'profile.signitureping': 'Gateway pinged Successfully',
  'profile.country': 'Country',
  'profile.city': 'City',
  'profile.role': 'Role',
  'profile.whoareyou': 'Who are you?',
  'profile.license': 'Add License',
  'profile.licenses': 'Licenses',
  'profile.removelicense': 'Remove License',
  'profile.addlicense': 'Add License',
  'profile.licensetype': 'Type',
  'profile.upload': 'Upload',
  'profile.completeprofilepoint':
    'To earn point, please complete your profile ',
  // "profile.completeprofilepoint2": "point , please complete your point",
  'profile.licenseno': 'License No',
  'profile.addresswithoutindex': 'Address',
  'profile.phonewithoutindex': 'Phone',
  'profile.underprocess': 'Under Process',
  'profile.fullname': 'FullName',
  'profile.airlinemarkup': 'Airline Markup',
  'profile.airlinename': 'Airline Name',
  'profile.airlinetype': 'Airline Type',
  'profile.quota': 'Quota',
  'profile.markup': 'Mark Up',
  'profile.savequota': 'Save Quota',
  'profile.currency': 'Currency',
  'profile.passportNumber': 'Passport Number',
  'profile.userPointType': 'User',
  'profile.point': 'Points',
  'profile.savepoint': 'Save Point',
  'profile.userpoint': 'User Point',
  'profile.subject': 'Subject',
  'profile.date': 'Assign Date',
  'profile.totaluserpoint': 'Total user point',
  'profile.viewdetails': 'View Details',
  'profile.provider': 'Provider',
  'profile.b2brequest': 'Service Request',
  'profile.language': 'Language',
  'profile.department': 'Department',
  'profile.adddetail': 'Add More Details(Optional)',
  'profile.identityno': 'Identity No',
  'profile.gateway': 'Gateway',
  'profile.hi': 'Hi',
  'profile.status': 'Status',
  'profile.copy': 'copied',
  'profile.approve': 'Approve',
  'profile.agree': 'Agree',
  'profile.dissapprove': 'DissApp',
  'profile.pending': 'Pending',
  'profile.notexitstuser': 'This username does not exist',
  'profile.selectrole': 'Please Select Role and Department',
  'profile.invitesuccessfully': 'Invitation sent successfully',
  'profile.description': 'Description',
  'profile.filldescription': 'Please enter description',
  'profile.dashboard': 'Dashboard',
  'profile.mydashboard': 'My Dashboard',
  'profile.saleaccounting': 'Sale Reports',
  'profile.profileaccounts': 'Accounts Management',
  'profile.commissionmanagement': 'Pointing',
  'profile.uploadlogo': 'Upload Your Company Logo',
  'profile.uploadlicense': 'Upload Your License',
  'profile.deleteprofile': 'Delete Profile',
  'profile.viewlicense': 'View Licenses',
  'profile.licensepic': 'License Picture',
  'profile.airlineCommission': 'Airline Commission/Markup Management',
  'profile.errordelete': 'It is not possible to delete this record',
  'profile.editverification': 'Are you sure to edit this profile',
  'profile.reference': 'Exporter Reference',
  'profile.logotitle': 'Click on the option below to edit the company logo',
  'profile.invitedepartment': 'Dear user, you have been invited to the ',
  'profile.inviteprofile': ' department in ',
  'profile.inviterole': ' business profile with the position of ',
  'profile.invite': '.If you wish, please confirm the invitation.',
  'profile.countercommission': 'Counter Commission',
  'profile.ownercommission': 'Owner Commission',
  'profile.bankaccounttype': 'Bank Account Type',
  'profile.newQuota': 'New Quota',
  'profile.commission': 'Profile Commission',
  'profile.addQuota': 'Add Quota',
  'profile.customermanagement': 'Customer Management',
  'profile.active': 'Active',
  'profile.disactive': 'Deactivate',
  'profile.Individual': 'Individual',
  'profile.bussiness': 'Business',
  'profile.postalcode': 'Postal Code',
  'profile.fax': 'Fax',
  'profile.accountingcode': 'Accounting Code',
  'profile.deletecustomer': 'Delete Customer',
  'profile.insertcustomer': 'Insert Customer',
  'profile.updatecustomer': 'Update Customer',
  'profile.both': 'both',
  'profile.reload': 'Reload',
  'profile.reloadfilter': 'Reload Filter',
  'profile.isbusiness': 'Is Business',
  'profile.isactive': 'Is Active',
  'profile.name': 'Name',
  'profile.registerdate': 'Register Date',
  'profile.chargewallet': 'Charge wallet',
  'profile.currentcredit': 'Current Credit',
  'profile.amount': 'Charge amount',
  'profile.chargecreditmessgae':
    'Charge your wallet to purchase easier and safety.',
  'profile.credit': 'Credit :',
  'profile.paymentdate': 'Payment date',
  'profile.businessbooking': 'My orders',
  'profile.gotpage': 'Return to charge wallet page',
  'profile.notfound': 'No records found!!!',
  'profile.message': 'Message',
  'profile.mypoint': 'My Point',
  'profile.pointtransaction': 'Point Transaction',
  'profile.buypoints': 'Buy Point',
  'profile.wallet': 'Wallet',
  'profile.chooseRole': 'Choose a role',
  'profile.mycredit': 'My Credit',
  'profile.tourManagement': 'Tour Management',
  'profile.departmentmanagement': 'Department Management',
  'profile.customerphrase': 'Full Name / Accounting Code',
  'profile.enterusername': 'Enter the desired username',
  'profile.menucredit': 'Credit :',
  'profile.personalprofile': 'Individual profile',
  'profile.employeesearch': 'Search by First Name,Last Name And Mobile',
  'profile.gotowalletpage': 'back to charge wallet page',
  'profile.documentdescription': 'Document Description',
  'profile.documentnumber': 'Document Number',
  'profile.registertime': 'Register Time',
  'profile.price': 'Price(IRR)',
  'profile.errorsecondpassword':
    'The second password and the repetition of the second password are not the same',
  'profile.successsecondpassword': 'The second password saved successfully',
  'profile.nowheretoursmanagement': 'NOWHERE TOURS MANAGEMENT',
  'profile.insertinformation': 'Insert Information',
  'profile.businessprofile': 'Business Profile',
  'profile.creditmanagement': 'Credit Management',
  'profile.affiliateMarketing': 'Affiliate',
  'profile.account': 'Account',
  'profile.individual': 'Individual',
  'profile.business': 'Business',
  'profile.myfriends': 'My Friends',
  'profile.viewCreditsAndWallets': 'View credits and  wallets',
  'profile.employeeManagement': 'Employee management',
  'profile.customerManagement': 'Customer management',
  'profile.transferType': 'Transfer Type',
  'profile.employeeList': 'Employee list',
  'profile.addEmployee': 'Add Employee',
  'profile.sendingInvitation': 'Sending invitation',
  'profile.employee': 'Employee',
  'profile.call': 'Call',
  'profile.message': 'Message',
  'profile.increaseOrEditCredentials': 'Increase or edit credentials',
  'profile.financialmanagement': 'Financial Management',
  'profile.messagedate': 'Message Date',
  'profile.startMessagedate': 'Start Message Date',
  'profile.endMessagedate': 'End Message Date',
  'profile.pointsremain': 'Point Remain',
  'profile.transaction': 'Transactions',
  'profile.messagedescription': 'Message Description',
  'profile.addCustomer': 'Add Customer',
  'profile.profileedit': 'Edit Profile',
  'profile.upgradeYourPlan': 'Upgrade your plan',
  'profile.planCustomer': 'Plan customer',
  'profile.walletremain': 'Wallet Remain',
  'profile.walletbalance': 'Wallet Balance',
  'profile.chargeamount': 'Charge Amount(IRR)',
  'profile.bankreceipt': 'Bank Receipt',
  'profile.online': 'Online',
  'profile.increasebalance': 'Increase Balance',
  'profile.selectedbills': 'Selected Bills',
  'profile.paymentbills': 'Payment Bills',
  'profile.sendToGroup': 'Send to group',
  'profile.theDesiredRole': 'The desired role',
  'profile.addDepartment': 'Add Department',
  'profile.employeeRole': 'Employee Role',
  'profile.moreDetails': 'More details',
  'profile.mehdiAbdollahiMehr': 'Mehdi Abdollahi Mehr',
  'profile.hiMessage': 'hi,where are you ?',
  'profile.inWork': 'Inwork',
  'profile.addNew': 'Add new',
  'profile.reminding': 'Reminding',
  'profile.participate': 'Participate',
  'profile.sportsInteractive': 'Sports Interactive',
  'profile.team': 'Team',
  'profile.tasks': 'tasks',
  'profile.chooseAnArtist': 'choose an artist',
  'profile.prepareForACallWithAClient': 'Prepare for a call with a client',
  'profile.prepareAEKTemplateForTheClient':
    'Prepare a EK template for the client',
  'profile.prepareDetiledBrief':
    'Prepare detiled brief for devs & 04:12  designers',
  'profile.more': 'More',
  'profile.position': 'Position',
  'profile.employeeInformation': 'Employee Information',
  'profile.employeeRegistrationDate': 'Employee registration date',
  'profile.creditAmount': 'Credit amount',
  'profile.theCeilingOfEachPurchase': 'ceiling of each purchase',
  'profile.validityDuration': 'Validity duration',
  'profile.creditStatus': 'Credit status',
  'profile.increaseCredit': 'Increase credit',
  'profile.editCredit': 'Edit credit',
  'profile.employeeCredit': 'Employee credit',
  'profile.creditBalance': 'Credit balance',
  'profile.aboutme': 'About me',
  'profile.myfavouritecity': 'My Favourite Cities',
  'profile.transferamount': 'Transfer Amount',
  'profile.loan': 'Loan',
  'profile.gift': 'Gift',
  'profile.messageType': 'Message Type',
  'profile.text': 'Text',
  'profile.file': 'File',
  'profile.customerList': 'Customer list',
  'profile.totalPurchaseAmount': 'Total purchase amount',
  'profile.topCustomers': 'Top Customers',
  'profile.homeAppliancesSeller': 'Home appliances seller',
  'profile.pointsInventory': 'Points inventory',
  'profile.pointCard': 'Point card',
  'profile.shoppingList': 'Shopping list',
  'profile.purchases': 'purchases',
  'profile.customerInformation': 'Customer Information',
  'profile.customerRegistrationDate': 'Customer registration date',
  'profile.customerShoppingList': 'Customer shopping list',
  'profile.incomeFromTheCustomer': 'Income from the customer',
  'profile.companyAddress': 'Company address',
  'profile.nameOfCEO': 'Name of CEO',
  'profile.registration/priceChange': 'Registration / price change',
  'profile.printPassengerInvoice': 'Print passenger invoice',
  'profile.registrationPaymentReceipts': 'Registration of payment receipts',
  'profile.priceToBuyFromOwner': 'Price to buy from the Tripsi',
  'profile.salesPriceCustomer': 'Sales price to the customer',
  'profile.salesManager': 'Sales Manager',
  'profile.showLess': 'Show less',
  'profile.purchaseRate': 'Purchase rate',
  'profile.changeTicketSalesRates': 'Change ticket sales rates',
  'profile.savePrice': 'Save price',
  'profile.remainingAmount': 'Remaining amount',
  'profile.firstPayment': 'First payment',
  'profile.settlementOfTickets': 'Settlement of tickets',
  'profile.totalAmount': 'Total Amount',
  'profile.attachedPaymentReceipt': 'Attached receipt',
  'profile.attachedPaymentReceipt1': 'First Attached receipt',
  'profile.attachedPaymentReceipt2': 'Second Attached receipt',
  'profile.attachedPaymentReceipt3': 'Third Attached receipt',
  'profile.attachedPaymentReceipt4': 'Fourth Attached receipt',
  'profile.attachedPaymentReceipt5': 'Fifth Attached receipt',
  'profile.totalRemaining': 'Total remaining',
  'profile.saveAndNextReceipt': 'Save and next receipt',
  'profile.saveAndExit': 'Save and exit',
  'profile.editEmployeeInformation': 'Edit employee information',
  'profile.travel': 'Travel',
  'profile.editconfirmation':
    'By submitting an edit request, your profile will be suspended until it is approved by Tripsi. Do you agree?',
  'profile.searchtobuy': 'Search to buy ratio',
  'profile.listOfPassengers': 'List of passengers',
  'profile.me': 'Tell about yourself.Get points',
  'profile.customer': 'customer',
  'profile.addcity': 'Add City',
  'profile.showinfo': 'Show Information',
  'profile.editPassengerInformation': 'Edit passenger information',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'Your passenger has been successfully registered',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'The requested passenger information was successfully edited',
  'profile.customerSuccessfullyRegistered': 'Customer successfully registered',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'The desired customer information was successfully edited',
  'profile.addfriend': 'Add Friend',
  'profile.inveitefriend': 'Invite Friends',
  'profile.inviteEmployees': 'Invite Employees',
  'profile.addEmployees': 'Add Employees',
  'profile.textLicense':
    'On this page you can see the licenses of the agency you want .',
  'profile.textEmployees':
    'Throught the form below , you can send invitations to employees who have left them company and have active usernames .',
  'profile.textCustomer':
    'Through the following form, you can add your desired customers to the collection by completing the following information.',
  'profile.textAddemplo':
    'Through the form below , you can add new employees to the company and monitor their performance through various features of the system .',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'Your passenger has been successfully registered',
  'profile.uploadText':
    'On this page, you can upload the desired profile by clicking on the link below.',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'The requested passenger information was successfully edited',
  'profile.customerSuccessfullyRegistered': 'Customer successfully registered',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'The desired customer information was successfully edited',
  'profile.editEmployeeSuccessfully': 'Edit Employee Successfully',
  'profile.updateEmployeeSuccess':
    'The employee information was successfully edited',
  'profile.mostSales': 'Most sales',
  'profile.theLowestNumberOfSales': 'Lowest sales',
  'profile.mostSalesAmount': 'Most sales amount',
  'profile.theLowestSalesAmount': 'The lowest sales amount',
  'profile.mostActivityTime': 'Most activity time',
  'profile.minimumActivityTime': 'Minimum activity time',
  'profile.employeeActivities': 'Employee activities',
  'profile.applyChanges': 'Apply Changes',
  'profile.planPassenger': 'Plan passenger',
  'profile.all': 'all',
  'profile.Activities': 'activities',
  'profile.allProfiles': 'profiles',
  'profile.allStatuses': 'statuses',
  'profile.dragtoadd': 'Drag to add',
  'profile.dragtotransfer': 'Drag to transfer',
  'profile.alltransactions': 'All Transactions',
  'profile.changedate': 'Change Date',
  'profile.startTravelDate': 'Start Travel Date',
  'profile.endTravelDate': 'End Travel Date',
  'profile.employeeSelection': 'Employee selection',
  'profile.sendMessage': 'Send message',
  'profile.groupSending': 'Group sending',
  'profile.showDetails': 'Show details',
  'profile.editingInformation': 'Editing Info',
  'profile.changeLogo': 'Change Logo',
  'profile.allocation': 'Allocation',
  'profile.allusers': 'All Users',
  'profile.onlineFriend': 'my online friends',
  '20 people online': ' people online ',
  'profile.recentTravels': ' Recent Travels ',
  'profile.mounthReport': 'Recent Month Performance Report ',
  'profile.recentNews': ' Recent News ',
  'profile.tourismNews': ' Tourism News ',
  'profile.recentMonthActivitie': ' Recent Month Activities ',
  'profile.NumberFlightPurchases': ' Number Of Flight Purchases ',
  'profile.NumberFlightSearches': ' Number Of Flight Searches ',
  'profile.services': 'Our Services',
  'profile.donutChart': 'Travels made',
  'profile.presensnt': 'peresenst',
  'profile.absence': 'absence',
  'profile.leave': 'leave',
  'profile.activeTour': 'Active Tours',
  'profile.finishedTour': 'Finshied Tours',
  'profile.createTour': 'Create Tour',
  'profile.choose': 'Choose',
  'profile.increaseCredit': 'Increase credit',
  'profile.textIncrease':
    'You can increase your credit through the form below .',
  'profile.textEditingTripsi':
    'You can change your profile information through the form below and note that after the profile changes, it will be suspended to be approved by Tripsi .',
  'profile.textEditingTripord':
    'You can change your profile information through the form below and note that after the profile changes, it will be suspended to be approved by Tripord .',
  'profile.textPassword':
    'You can change your password and define your new password through the form below.',
  'profile.reservations': 'Reservations',
  'profile.row': 'Row',
  'profile.transactions': 'Transactions',
  'profile.searchHistory': 'Search History',
  'profile.Transactions': 'Transactions',
  'profile.Invoices': 'Invoices',
  'profile.assetManagment': 'Asset Management',
  'profile.Invoice': 'Invoice',
  'profile.Credit': 'credit',
  'profile.myProfile': 'My Profile',
  'profile.textProfile':
    'In this section you can see your profile information .',
  'profile.textAddfriend':
    'you can send an invitation to your friends through the following form and add them to your friends list .',
  'profile.textFriend':
    'Through the form below, you can enter the information of your friends and register the information at the end. ',
  'profile.textDepartment':
    'You can register or re-address the desired department through the form below.',
  'profile.Invite': 'Invite',
  'profile.add': 'Add',
  'profile.passengers': 'Passengers',
  'profile.messages': 'Messages',
  'profile.Services': 'Services',
  'profile.Info': 'Info',
  'profile.transportation': 'Transport',
  'profile.inhabitancy': 'Inhabitancy',
  'profile.facilities': 'Facilities',
  'profile.pricing': 'Pricing',
  'profile.clubCard': 'Club Card',
  'profile.messageNo': 'Message No',
  'profile.viewInvoice': 'View The Invoice',
  'profile.loading': 'Loading...',
  'profile.moreAddressees': 'Show more addresses',
  'profile.morePhoneNumbers': 'Show more phone numbers',
  'profile.flight': 'Flight',
  'profile.paid': 'Paid',
  'profile.unpaid': 'UnPaid',
  'profile.choosefile': 'Choose File',
  'profile.sellername': `Name's Seller`,
  'profile.factoreno': 'Factore No',
  'profile.customername': 'Customer Name',
  'profile.phonenumber': 'Mobile Number',
  'profile.printinvoice': 'Print Invoice',
  'profile.signature': 'Accounting Stamp and Signature',
  'profile.signaturetext': 'Without Seal and Signature, Accounting is Invalid.',
  'profile.servicedescription': 'Service Description',
  'profile.taxesduties': 'Taxes and Duties',
  'profile.purchaseamount': 'Purchase Amount',
  'profile.friendsearch': 'Name, National code, Passport No',
  'profile.ticketsearch': 'Title, Ticket No',
  'profile.messagesearch': 'Subject, Message No',
  'profile.bookingflightsearch': 'Name, Order No',
  'profile.transactionsearch': 'Name, Order No',
  'profile.employeesearch': 'Name, Email',
  'profile.customersearch': 'Customer Name',
  'profile.passangersearch': 'Name, National code, Passport No',
  'profile.activities': 'Activities',
  'profile.addlicenselink': 'Add License',
  'profile.startnewsevent': 'Start Event',
  'profile.endnewsevent': 'End Event',
  'profile.descriptionnews': 'News Text : ',
  'profile.introduction': 'Introduction',
  'profile.firsttravel': 'Waiting for the First Trip...',
  'profile.transactionnumber': 'Transaction code : ',
  'profile.notfoundnews': 'Not Found News',
  'profile.notfoundtravel': `You haven't traveled yet.`,
  'profile.waitingTrip': 'We are waiting for your first trip...',
  'profile.addLicenseText':
    'Through the form below, you can enter your permissions and register information at the end.',
  'profile.simpleuser': 'Normal User',
  'profile.owner': 'Owner',
  'profile.crm': 'CRM',
  'profile.counter': 'Counter',
  'profile.accountants': 'Accountants',
  'profile.roles': 'Roles',
  'profile.submitchangerate': 'Sales Rate Change Was Successful',
  'profile.paymentprice': 'Payment Price',
  'profile.savesuccessfully': 'Save Successfully',
  'profile.viewfile': 'View File',
  'profile.backgammon': 'Backgammon',
  'profile.chatgpt': 'Chat gpt',
  'profile.calendar': 'Calendar',
  'profile.game': 'Game',
  'profile.addgateway': 'Add Flight Route',
  'profile.editgateway': 'Edit Flight Route',
  'profile.addgatewaydescription':
    'In this form, you can register your desired flight route. After registration, searches will be conducted according to the registered flight routes.',
  'profile.editgatewaydescription':
    'In this form, you can edit your desired flight route. After editing, searches will be conducted according to the registered flight routes.',
  'profile.gatewayroutes': 'Flight Routes',
  'profile.airlinecode': 'Airline Code',
  'profile.internalcode': 'Internal Code',
  'profile.weekdays': 'Weekdays',
  'profile.known': 'Known',
  'profile.unknown': 'Unknown',
  'profile.airlinestatus': 'Airline Status',
  'profile.allroutes': 'All Routes',
  'profile.selectoriginanddestination': 'Origin and Destination',
  'profile.siti': 'SITI',
  'profile.sito': 'SITO',
  'profile.soti': 'SOTI',
  'profile.soto': 'SOTO',
  'profile.pathchoice': 'Path Choice',
  'profile.submiteditgateway': 'Submit Edit Route',
  'profile.submitaddgateway': 'Submit Add Route',
  'profile.selectflightsdays': 'Select Flight Days',
  'profile.departureflightcity': 'Departure City',
  'profile.arrivalflightcity': 'Arrival City',
  'profile.ascinternalcode': 'Ascending Internal Code',
  'profile.descinternalcode': 'Descending Internal Code',
  'profile.ascairlinecode': 'Ascending Airline Code',
  'profile.descairlinecode': 'Descending Airline Code',
  'profile.addgatewaysuccessfully': 'Flight route successfully added',
  'profile.editgatewaysuccessfully': 'Flight route successfully edited',
  'profile.notallowed': "It dosen't allow to select profile before approve it",
  'profile.addcustomerduplicated': 'The desired customer is already registered',
  'profile.discount': 'Discount',
  'profile.sendfile': 'Send Bank Receipt',
  'profile.sendfiles': 'Send Bank Receipts',
  'profile.factorestartdate': 'Invoice Start Date',
  'profile.factoreenddate': 'Invoice End Date',
  'profile.factoredate': 'Invoice Date',
  'profile.allfactors': 'All Invoices',
  'profile.walletnotenough': 'Wallet balance is not sufficient',
  'profile.approvePrice': 'Approved Price',
  'profile.textSecondPassword':
    'Through the following form, you can change your second static password and define your new second static password.',
  'profile.changesecondpassword': 'change second pass',
  'profile.oldsecondpassword': 'Old Second Password',
  'profile.setSecondPasswordInfo':
    'If you are setting the second password for the first time, there is no need to enter this field.',
};
